module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    staticClass: "margin-b-20",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "title": "",
      "type": "error",
      "closable": false
    }
  }, [_vm._t("default", [_c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('ul', _vm._l((_vm.materials), function(material) {
    return _c('li', {
      key: material.id
    }, [_vm._v("\n          " + _vm._s(material.name) + " (" + _vm._s(_vm.$t('table.recipeIngrediences.amount.label')) + ":" + _vm._s(material.needed_qty) + ") - " + _vm._s(_vm.$t('static.stock.products.currentCount')) + ": " + _vm._s(material.current_qty) + "\n        ")])
  }), 0)])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-direction": "column"
    }
  }, _vm._l((_vm.buttons), function(button) {
    return _c('el-button', {
      staticClass: "margin-b-20",
      staticStyle: {
        "width": "380px"
      },
      on: {
        "click": button.action
      }
    }, [_vm._v("\n      " + _vm._s(button.name) + "\n  ")])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040d5756","hasScoped":false}!./src/app/components/batchStartPopup/batchStartPopup.html
// module id = 2893
// module chunks = 1